import forEach from 'lodash/forEach';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import compose from 'recompose/compose';
import moment from 'moment';
import uuidV4 from 'uuid/v4';
import {document} from 'ssr-window';
import DOMUtils from '@spothero/utils/dom';
import Button from '@spothero/ui/button';
import DatePicker from '@spothero/ui/date-picker';
import Modal from '@spothero/ui/modal';
import ModalContent from '@spothero/ui/modal-content';
import TextButton from '@spothero/ui/text-button';
import TextInput from '@spothero/ui/text-input';
import SHLoader from 'common/loader/SHLoader';
import Icon from 'common/icon/Icon';
import WithConfig from 'config/WithConfig';
import EventListItem from './EventListItem';
import WithEventList from './WithEventList';

class EventListDesktop extends Component {
    static propTypes = {
        displayDateFormat: PropTypes.string.isRequired,
        city: PropTypes.object.isRequired,
        destination: PropTypes.object,
        isLoading: PropTypes.bool,
        loadData: PropTypes.func.isRequired,
        onEventSelected: PropTypes.func.isRequired,
        onHidden: PropTypes.func.isRequired,
        isPrerender: PropTypes.bool.isRequired
    };
    state = {
        date: '',
        name: '',
        key: uuidV4()
    };

    constructor(props) {
        super(props);

        this._isExternalReferral = !includes(document.referrer, 'spothero');
    }

    componentDidMount() {
        this.props.loadData();
    }

    _onDateChange = selectedDate => {
        this.setState({
            date: selectedDate
        });
    }

    _onInputChange = evt => {
        this.setState({
            name: evt.target.value
        });
    }

    _onClearClick = evt => {
        this.setState({
            date: '',
            name: '',
            key: uuidV4()
        });
    }

    _onHideClick = evt => {
        this._modal.hide();
    }

    _onEventSelected = event => {
        this.props.onEventSelected(event);
    }

    _onClearExistingModals = () => {
        const existingModal = DOMUtils.el('.Modal');

        if (existingModal) {
            existingModal.parentNode.removeChild(existingModal);
        }
    }

    _getFilteredEvents() {
        const {
            displayDateFormat,
            destination
        } = this.props;
        const {
            date,
            name
        } = this.state;
        const events = [];
        const hasDateFilter = !isEmpty(date);
        const hasNameFilter = !isEmpty(name);
        let formattedDate = null;

        forEach(destination.events, event => {
            formattedDate = moment(event.starts).format(displayDateFormat);

            if (hasNameFilter && hasDateFilter) {
                if (includes(event.title.toUpperCase(), name.toUpperCase()) && includes(formattedDate, date)) {
                    events.push(event);
                }
            } else if (hasNameFilter) {
                if (includes(event.title.toUpperCase(), name.toUpperCase())) {
                    events.push(event);
                }
            } else {
                if (includes(formattedDate, date)) {
                    events.push(event);
                }
            }
        });

        return events;
    }

    _renderTitle() {
        const {
            destination: {
                title
            }
        } = this.props;
        const classes = classNames(
            {'EventListDesktop-referred-title': this._isExternalReferral}
        );

        return (
            <Fragment>
                {this._isExternalReferral &&
                    <div className="EventListDesktop-referred">
                        <a href="/"><Icon name="spothero" /></a> <span>Reserve convenient parking and save up to 50%</span>
                    </div>
                }
                <h1 className={classes}>{title} Parking</h1>
            </Fragment>
        );
    }

    render() {
        const {
            isLoading,
            destination,
            city,
            onHidden,
            isPrerender
        } = this.props;
        const {
            timezone
        } = city;
        const {
            title,
            venue_content_enabled: contentEnabled,
            venue_content: content
        } = destination;
        const {
            key
        } = this.state;
        const events = this._getFilteredEvents();

        return (
            <Fragment>
                {(isPrerender || (destination.events && destination.events.length > 0)) &&
                    <Modal
                        ref={node => { this._modal = node; }}
                        className="EventListDesktop"
                        title={this._renderTitle()}
                        onHidden={onHidden}
                        animateOnShow={false}
                        onBeforeFirstRender={this._onClearExistingModals}
                    >
                        <ModalContent>
                            {(isLoading)
                                ? (
                                    <div className="Loader-container">
                                        <SHLoader
                                            additionalMarkup={<p>Loading {title} events...</p>}
                                        />
                                    </div>
                                ) : (
                                    <div className="EventListDesktop-wrapper">
                                        <h2 className="heading-sm">Heading to {title}? Select your event below to get the best spot at the best price.</h2>
                                        {(content && contentEnabled) &&
                                            <h2 className="heading-sm">{content}</h2>
                                        }
                                        <p>Filter by:</p>
                                        <div
                                            key={key}
                                            className="EventListDesktop-filters"
                                        >
                                            <DatePicker
                                                id="EventListDesktop-event-date"
                                                placeholder="Event Date"
                                                onChange={this._onDateChange}
                                                disabled={isPrerender}
                                            />
                                            <TextInput
                                                placeholder="Event Name"
                                                onChange={this._onInputChange}
                                                disabled={isPrerender}
                                            />
                                            <TextButton
                                                onClick={this._onClearClick}
                                                disabled={isPrerender}
                                            >
                                                Clear
                                            </TextButton>
                                        </div>
                                        {(events.length > 0)
                                            ? (
                                                <Fragment>
                                                    <div className="EventListDesktop-events">
                                                        {events.map(event => {
                                                            return (
                                                                <EventListItem
                                                                    key={event.id}
                                                                    event={event}
                                                                    timezone={timezone}
                                                                    destination={destination}
                                                                    city={city}
                                                                    onClick={this._onEventSelected}
                                                                    isMobile={false}
                                                                />
                                                            );
                                                        })}
                                                    </div>
                                                    <Button
                                                        className="EventListDesktop-not-event"
                                                        color="secondary"
                                                        iconPosition="right"
                                                        onClick={this._onHideClick}
                                                        disabled={isPrerender}
                                                    >
                                                        I&apos;m not looking for an event
                                                        <Icon name="chevron-right" />
                                                    </Button>
                                                </Fragment>
                                            ) : (
                                                <p className="EventListDesktop-no-results">
                                                    No Results
                                                    <TextButton
                                                        onClick={this._onClearClick}
                                                        disabled={isPrerender}
                                                    >
                                                        Clear Filters
                                                    </TextButton>
                                                </p>
                                            )
                                        }
                                    </div>
                                )
                            }
                        </ModalContent>
                    </Modal>
                }
            </Fragment>
        );
    }
}

const enhance = compose(
    WithConfig,
    WithEventList
);

export default enhance(EventListDesktop);
